import '../styles/index.scss';

let fleet, enemyFleet, config;

function Fleet() {
	this.ships = [];
	this.currentShip = 0;
	this.initShips = function() {
		for(let i = 0; i < this.numOfShips; i++) {
			this.ships[i] = Object.assign(new Ship(), this.ships[i]);
		}
	};
	this.removeShip = function(pos) {
		this.numOfShips--;
		if (this == fleet) enemy.sizeOfShipSunk = this.ships[pos].length;
		this.ships.splice(pos, 1);
		return true;
	};
	this.shipHit = function() {
		return true;
	};
	this.checkIfHit = function(point) {
		for(let i = 0; i < this.numOfShips; i++) {
			if (this.ships[i].hitPoints.indexOf(point) != -1) {
				this.ships[i].removeHitPoints(this.ships[i].hitPoints.indexOf(point));
				if (this.ships[i].hitPoints == 0)return this.removeShip(i);
				else return this.shipHit(this.ships[i].name);
			}
		}
		return false;
	};
}

function Ship(){
	this.populateHorzHits = function(start) {
		for (let i = 0; i < this.length; i++, start++) {
			this.hitPoints[i] = start;
		}
	};
	this.populateVertHits = function(start) {
		for (let i = 0; i < this.length; i++, start += 10) {
			this.hitPoints[i] = start;
		}
	};
	this.checkLocation    = function(loc) {
		for (let i = 0; i < this.length; i++) {
			if ( [loc,loc-11,loc-10,loc-9,loc-1,loc+1,loc+9,loc+10,loc+11].indexOf(this.hitPoints[i]) > -1) return true;
		}
		return false;
	};
	this.removeHitPoints  = function(pos) {
		this.hitPoints.splice(pos, 1);
	};
}

let enemyBoard = {
	allHits: [],
	highlight: function(square) {
		$(square).addClass("target").off("mouseleave").on("mouseleave", function() {
			$(this).removeClass("target");
		});

		$(square).off("click").on("click", function() {
			if(!($(this).hasClass("used"))) {
				$(this).removeClass("target").addClass("used");
				let num = parseInt($(this).attr("class").slice(15));
				console.log(num);
				let bool = enemyFleet.checkIfHit(num);
				if (false == bool) {
					$(this).children().addClass("failed-hit");
				} else $(this).children().addClass("successful-hit");
				$(".enemy").find(".points").off("mouseenter").off("mouseover").off("mouseleave").off("click");

				if (enemyFleet.ships.length == 0) {
					$(".enemy").find(".points").off("mouseenter").off("mouseover").off("mouseleave").off("click");
					alert("All ships have sunk and game is over. You win.");
				} else setTimeout(enemy.select, 800);
			}
		});
	},
};

let playerBoard = {
	currentHits: [],
	checkAttempt: function(hit) {
		if (fleet.checkIfHit(hit)) {
			playerBoard.currentHits.push(hit);
			if (this.currentHits.length > 1) enemy.prevHit = true;
			$(".player").find("." + hit).children().addClass("successful-hit");
			if (playerBoard.hasShipBeenSunk()) {
				enemy.hunting = enemy.prevHit = false;
				if (enemy.sizeOfShipSunk == playerBoard.currentHits.length) {
					enemy.numMisses = enemy.backCount = enemy.nextMove.length = playerBoard.currentHits.length = enemy.sizeOfShipSunk = enemy.currrent = 0;
				} else {
					enemy.special =  enemy.case1 = true;
				}
				if (enemy.specialHits.length > 0) enemy.special = true;
				return false;
			}
			return true;
		} else {
			$(".player").find("." + hit).children().addClass("failed-hit");
			enemy.current = playerBoard.currentHits[0];
			enemy.prevHit = false;
			if (playerBoard.currentHits.length > 1) {
				enemy.back = true;
				enemy.numMisses++;
			}
			if (enemy.case2) {
				enemy.special = true;
				enemy.case2   = false;
			}
			return false;
		}
	},

	hasShipBeenSunk: function() {
		return enemy.sizeOfShipSunk > 0;
	}
};

let enemy = {
	back:                false,
	hunting:             false,
	prevHit:             false,
	firstHit:            false,
	special:             false,
	case1:               false,
	case2:               false,
	numMisses:           0,
	backCount:           0,
	randPool:            [],
	nextMove:            [],
	attempted:           [],
	specialHits:         [],
	direction:           "",
	current:             0,
	numAttemptsAfterHit: 0,
	sizeOfShipSunk:      0,
	randomGen:           function(size) {
		return Math.floor(Math.random() * size);
	},
	select:              function() {
		if (enemy.hunting) {
			enemy.battleLogic();
		} else if (enemy.special) {
			enemy.specialCase();
		} else {
			enemy.current = enemy.randPool[enemy.randomGen(enemy.randPool.length)];
			enemy.attempted.push(enemy.current);
			enemy.firstHit = true;
			enemy.removeGuess(enemy.randPool.indexOf(enemy.current));
			enemy.hunting = playerBoard.checkAttempt(enemy.current);
		}
		setTimeout(hoverBoard(), 50);
	},

	removeGuess: function(index) {
		enemy.randPool.splice(index, 1);
	},

	battleLogic: function() {
		if (enemy.firstHit) {
			enemy.createMoves();
			enemy.firstHit = false;
		}

		if (enemy.numMisses > 1) {
			enemy.specialCase();
		} else if (enemy.back) {
			enemy.back = false;
			enemy.backy();
			enemy.deployHit(enemy.current);
		} else if (enemy.prevHit) {
			enemy.continueHits();
			enemy.deployHit(enemy.current);
		} else {
			enemy.direction = enemy.nextMove.pop();
			enemy.getNumericalDirection(enemy.direction);
			enemy.prevHit = enemy.deployHit(enemy.current);
		}
	},

	deployHit: function(hit) {
		if (enemy.special) {
			enemy.specialCase();
		} else {
			enemy.attempted.push(hit);
			enemy.removeGuess(enemy.randPool.indexOf(hit));
			return playerBoard.checkAttempt(hit);
		}
	},

	createMoves: function() {
		if(enemy.current == 1) {
			enemy.getRandomMoves(["right", "down"]);
		}
		else if(enemy.current == 10) {
			enemy.getRandomMoves(["left", "down"]);
		}
		else if(enemy.current == 91) {
			enemy.getRandomMoves(["up", "right"]);
		}
		else if(enemy.current == 100) {
			enemy.getRandomMoves(["left", "up"]);
		}
		else if(!(enemy.current % 10)){
			enemy.getRandomMoves(["up", "down", "left"]);
		}
		else if(enemy.current < 10) {
			enemy.getRandomMoves(["right", "down", "left"]);
		}
		else if(enemy.current % 10 == 1) {
			enemy.getRandomMoves(["up", "right", "down"]);
		}
		else if(enemy.current > 91) {
			enemy.getRandomMoves(["up", "right", "left"]);
		}
		else {
			enemy.getRandomMoves(["up", "right", "down", "left"]);
		}
	},

	getRandomMoves: function(possibleMoves) {
		while (possibleMoves.length != 0) {
			let dir = enemy.randomGen(possibleMoves.length);
			if (possibleMoves[dir] == "up") {
				if (enemy.randPool.some(function(x) { return x == enemy.current - 10; })) {
					enemy.nextMove.push("up");
				}
			}
			if (possibleMoves[dir] == "right") {
				if (enemy.randPool.some(function(x) { return x == enemy.current + 1; })) {
					enemy.nextMove.push("right");
				}
			}
			if (possibleMoves[dir] == "down") {
				if (enemy.randPool.some(function(x) { return x == enemy.current + 10; })) {
					enemy.nextMove.push("down");
				}
			}
			if (possibleMoves[dir] == "left") {
				if (enemy.randPool.some(function(x) { return x == enemy.current - 1; })) {
					enemy.nextMove.push("left");
				}
			}
			possibleMoves.splice(dir, 1);
		}
	},

	getNumericalDirection: function(dir) {
		if (dir == "up") enemy.current -= 10;
		if (dir == "right") enemy.current += 1;
		if (dir == "down") enemy.current += 10;
		if (dir == "left") enemy.current -= 1;

		if (enemy.attempted.some(function(x) { return x == enemy.current; }) && enemy.specialHits.length == 0) {
			enemy.current = playerBoard.currentHits[0];
			if (enemy.backCount > 1) enemy.special = true;
			else enemy.backy();
		}
		return false;
	},

	continueHits: function() {
		if (enemy.direction == "up") {
			if (enemy.checkLocation("up")) {
				enemy.direction = "down";
				return enemy.getNumericalDirection(enemy.direction);
			} else return enemy.getNumericalDirection(enemy.direction);
		}
		if (enemy.direction == "right") {
			if (enemy.checkLocation("right")) {
				enemy.direction = "left";
				return enemy.getNumericalDirection(enemy.direction);
			} else return enemy.getNumericalDirection(enemy.direction);
		}
		if (enemy.direction == "down") {
			if (enemy.checkLocation("down")) {
				enemy.direction = "up";
				return enemy.getNumericalDirection(enemy.direction);
			} else return enemy.getNumericalDirection(enemy.direction);
		}
		if (enemy.direction == "left") {
			if (enemy.checkLocation("left")) {
				enemy.direction = "right";
				return enemy.getNumericalDirection(enemy.direction);
			} else return enemy.getNumericalDirection(enemy.direction);
		}
	},

	backy: function() {
		enemy.backCount++;
		if (enemy.direction == "up") {
			enemy.direction = "down";
			return enemy.continueHits();
		}
		if (enemy.direction == "right") {
			enemy.direction = "left";
			return enemy.continueHits();
		}
		if (enemy.direction == "down") {
			enemy.direction = "up";
			return enemy.continueHits();
		}
		if (enemy.direction == "left") {
			enemy.direction = "right";
			return enemy.continueHits();
		}
	},

	checkLocation: function(dir) {
		if (dir == "up") {
			if (enemy.current < 11) return true;
		}
		if (dir == "right") {
			if (enemy.current % 10 == 0) return true;
		}
		if (dir == "down") {
			if (enemy.current > 90) return true;
		}
		if (dir == "left") {
			if (enemy.current % 10 == 1) return true;
		}
		return false;
	},

	specialCase: function() {
		enemy.numMisses = enemy.backCount = enemy.nextMove.length = 0;
		if (enemy.case1) {
			enemy.prevHit = true;
			if (enemy.getNewCurrent(enemy.direction)) {
				playerBoard.currentHits.length = 0;
				playerBoard.currentHits.push(enemy.current);
				enemy.firstHit = true;
				enemy.prevHit  = false;
			}
			enemy.special        = enemy.case1 = enemy.back = false;
			enemy.hunting        = true;
			enemy.sizeOfShipSunk = 0;
			enemy.battleLogic();
		} else {
			if (enemy.specialHits.length == 0) {
				for(let i = 0; i < playerBoard.currentHits.length; i++) {
					enemy.specialHits.push(playerBoard.currentHits[i]);
				}
				playerBoard.currentHits.length = 0;
			}
			enemy.current = enemy.specialHits.pop();
			playerBoard.currentHits.push(enemy.current);
			enemy.special  = enemy.back = enemy.prevHit = false;
			enemy.firstHit = enemy.hunting = true;
			enemy.battleLogic();
		}
	},

	getNewCurrent: function(direction) {
		let difference = playerBoard.currentHits.length - enemy.sizeOfShipSunk;
		if (enemy.direction == "up") {
			enemy.direction = "down";
			if (difference > 1) {
				enemy.current += 10 * (playerBoard.currentHits.length - 1);
				let temp = enemy.current + (10 * (difference - 1));
				playerBoard.currentHits.length = 0;
				for (let i = 0; i < difference; i++) {
					playerBoard.currentHits.push(temp);
					temp += 10;
				}
				enemy.case2 = true;
				return false;
			}
			enemy.current += 10 * enemy.sizeOfShipSunk;
			return true;
		}
		if (enemy.direction == "right") {
			enemy.direction = "left";
			if (difference > 1) {
				enemy.current -= playerBoard.currentHits.length - 1;
				let temp = enemy.current + (difference - 1);
				playerBoard.currentHits.length = 0;
				for (let i = 0; i < difference; i++) {
					playerBoard.currentHits.push(temp);
					temp -= 1;
				}
				enemy.case2 = true;
				return false;
			}
			enemy.current -= enemy.sizeOfShipSunk;
			return true;
		}
		if (enemy.direction == "down") {
			enemy.direction = "up";
			if (difference > 1) {
				enemy.current -= 10 * (playerBoard.currentHits.length - 1);
				let temp = enemy.current - (10 * (difference - 1));
				playerBoard.currentHits.length = 0;
				for (let i = 0; i < difference; i++) {
					playerBoard.currentHits.push(temp);
					temp -= 10;
				}
				enemy.case2 = true;
				return false;
			}
			enemy.current -= 10 * enemy.sizeOfShipSunk;
			return true;
		}
		if (enemy.direction == "left") {
			enemy.direction = "right";
			if (difference > 1) {
				enemy.current += playerBoard.currentHits.length - 1;
				let temp = enemy.current - (difference - 1);
				playerBoard.currentHits.length = 0;
				for (let i = 0; i < difference; i++) {
					playerBoard.currentHits.push(temp);
					temp += 1;
				}
				enemy.case2 = true;
				return false;
			}
			enemy.current += enemy.sizeOfShipSunk;
			return true;
		}
	}
};

$(document).ready(function() {
	generateBoard();

	$.getJSON( "api/start", function( data ) {
		config = data;
		gameInit();
	});
});

function generateBoard() {
		for (let i = 1; i <= 100; i++) {
			if (i < 11) {
				$(".enemy").prepend("<span class='numbers'>" + Math.abs(i - 11) + "</span>");
				$(".player").prepend("<span class='numbers'>" + Math.abs(i - 11) + "</span>");
				$(".board").append("<li class='points offset1 " + i + "'><span></span></li>");
			} else {
				$(".board").append("<li class='points offset2 " + i + "'><span></span></li>");
			}
			if (i == 11) {
				$(".enemy").prepend("<span class='numbers'></span>");
				$(".player").prepend("<span class='numbers'></span>");
			}
			if (i > 90) {
				$(".enemy").append("<span class='letters'>" +
					String.fromCharCode(97 + (i - 91)).toUpperCase() + "</span>");
				$(".player").append("<span class='letters'>" +
					String.fromCharCode(97 + (i - 91)).toUpperCase() + "</span>");
			}
		}
}

function gameInit() {
	fleet = Object.assign(new Fleet(), config.fleets[0]);
	fleet.initShips();
	randomInit(fleet);
}

function randomInit(fleet) {
	if (fleet.currentShip >= fleet.numOfShips) return;

	let orien = Math.floor((Math.random() * 10) + 1);
	let length = fleet.ships[fleet.currentShip].length;
	let shipOffset, randNum;

	if (orien < 6) {
		shipOffset = 10 - fleet.ships[fleet.currentShip].length;
		let horiz = Math.floor((Math.random() * shipOffset) + 1);
		let vert = Math.floor(Math.random() * 9);
		randNum = parseInt(String(vert) + String(horiz));
		if (fleet == enemyFleet) checkOverlap(randNum, length, "horz", fleet);
		else setupShip(randNum, fleet.ships[fleet.currentShip], "horz", fleet, "random");
	} else {
		shipOffset = 110 - (fleet.ships[fleet.currentShip].length * 10);
		randNum = Math.floor((Math.random() * shipOffset) + 1);

		if (fleet == enemyFleet) checkOverlap(randNum, length, "vert", fleet);
		else setupShip(randNum, fleet.ships[fleet.currentShip], "vert", fleet, "random");
	}
}

function createEnemyFleet() {
	enemyFleet = Object.assign(new Fleet(), config.fleets[1]);
	enemyFleet.initShips();
	randomInit(enemyFleet);
}

function setupShip(location, ship, orientation, genericFleet, type) {
	if (!(checkOverlap(location, ship.length, orientation, genericFleet))) {
		if (orientation == "horz") {
			genericFleet.ships[genericFleet.currentShip].populateHorzHits(location);
			for (let i = location; i < (location + ship.length); i++) {
				$(".player ." + i).addClass(genericFleet.ships[genericFleet.currentShip].name);
			}
			if (++genericFleet.currentShip == genericFleet.numOfShips) {
				$(".player").find(".points").off("mouseenter");
				setTimeout(createEnemyFleet, 100);
			} else {
				randomInit(genericFleet);
			}

		} else {
			let inc = 0;
			genericFleet.ships[genericFleet.currentShip].populateVertHits(location);
			for (let i = location; i < (location + ship.length); i++) {
				$(".player ." + (location + inc)).addClass(genericFleet.ships[genericFleet.currentShip].name);
				inc = inc + 10;
			}
			if (++genericFleet.currentShip == genericFleet.numOfShips) {
				$(".player").find(".points").off("mouseenter");

				setTimeout(createEnemyFleet, 100);
			} else {
				randomInit(genericFleet);
			}
		}
	} else {
		randomInit(genericFleet);
	}
}

function checkOverlap(location, length, orientation, genFleet) {
	let loc = location;
	if (orientation == "horz") {
		let end = location + length;
		for (; location < end; location++) {
			for (let i = 0; i < genFleet.currentShip; i++) {
				if (genFleet.ships[i].checkLocation(location)) {
					if (genFleet == enemyFleet) randomInit(genFleet);
					else return true;
				}
			}
		}
	} else {
		let end = location + (10 * length);
		for (; location < end; location += 10) {
			for (let i = 0; i < genFleet.currentShip; i++) {
				if (genFleet.ships[i].checkLocation(location)) {
					if (genFleet == enemyFleet) randomInit(genFleet);
					else return true;
				}
			}
		}
	}
	if (genFleet == enemyFleet && genFleet.currentShip < genFleet.numOfShips) {
		if (orientation == "horz") genFleet.ships[genFleet.currentShip++].populateHorzHits(loc);
		else genFleet.ships[genFleet.currentShip++].populateVertHits(loc);
		if (genFleet.currentShip == genFleet.numOfShips) {

			setTimeout(beginGame, 500);
		} else randomInit(genFleet);
	}
	return false;
}

function beginGame() {
	for (let i = 0; i < 100; i++) enemy.randPool[i] = i + 1;
	hoverBoard();
}

function hoverBoard() {
	if (fleet.ships.length == 0) {
		$(".enemy").find(".points").off("mouseenter").off("mouseleave").off("click");
		alert("All ships have sunk and game is over. You lose.");
	} else {
		$(".enemy").find(".points").off("mouseenter mouseover").on("mouseenter mouseover", function() {
			if(!($(this).hasClass("used"))) enemyBoard.highlight(this);
		});
	}
}
